PJQ.views.schedule.TemplateManagement = PJQ.views.templates.TemplateManagement.extend({
    beforeFirstRender: function () {
        this.collection = new PJQ.collections.schedule.Templates();
        this.listenTo(this.collection, 'fetch', this.render);
        this.collection.fetch();
    },
    addTemplate: function () {
        new PJQ.views.templates.NewTemplateModal({
            model: new PJQ.models.schedule.Template(),
            onSave: _.bind(function (template) {
                this.collection.add(template);
                this.editTemplate(template);
            }, this)
        });
    },
    editTemplate: function (template) {
        new PJQ.views.schedule.EditTemplateModal({
            model: template,
            onClose: _.bind(function () {
                this.dataTable.refresh();
            }, this),
            onDelete: _.bind(function (template) {
                if (template.id > 0) {
                    let row = this.dataTable.getRow(template.cid);
                    this.collection.remove(template);
                    template.destroy();
                    this.dataTable.removeRow(row);
                }
            }, this)
        });
    }
});

PJQ.views.schedule.EditTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Edit-Template'),
        maxWidth: '90%',
        fitHeight: true,
        onClose: null
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-delete': 'deleteTemplate'
    },
    beforeModalCreated: function () {
        this.listenTo(this.model, 'fetch', this.render);
        this.model.fetch();
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        if (this.model.isFetched) {
            // new PJQ.Alert(this.$('.manage-template-alert'), {
            // 	text: "Task start and finish dates are shown as they were originally saved.  When importing these templates on a project, you will be asked to specify a start date.  All task dates will be modified according using the start date provided.",
            // 	isPrepend: true,
            // 	cookie: PJQ.constants.cookies.SCHEDULE_TEMPLATE_DATES_ORIGIN
            // });

            new PJQ.inputs.TextEditorInput({
                el: this.$('.edit-template-name'),
                label: 'Name',
                value: this.model.get('name'),
                onSave: _.bind(function (value) {
                    this.model.patch({
                        name: value
                    });
                }, this)
            });

            new PJQ.views.schedule.ScheduleDashboard({
                el: this.$('.manage-template'),
                model: this.model
            });
        }
    },
    close: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose(this.model);
        }
    },
    deleteTemplate: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this template?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.schedule.SaveAsTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Save-As-Template'),
        maxWidth: 500
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        this.model = new PJQ.models.schedule.Template({
            projectId: this.options.project.id
        });

        this.options.project.fetchScheduleTemplates(_.bind(function (tmp) {
            this.templates = tmp;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            templates: this.templates
        };
    },
    afterRender: function () {
        if (this.templates != null && this.templates.isFetched) {
            new PJQ.inputs.AutocompleteInput({
                el: this.$('.input-template-name'),
                source: _.map(this.templates.models, function (template) {
                    return template.get('name')
                })
            });
        }
    },
    save: function () {
        let $name = this.$('.input-template-name'),
            name = $name.val();
        if (_.size(name.trim()) === 0) {
            PJQ.helpers.inputHelpers.setInputError($name);
            return;
        } else {
            PJQ.helpers.inputHelpers.setInputError($name, true);
        }

        let existingTemplate = this.templates.findWhere({name: name}),
            fnSave = _.bind(function () {
                this.model.set({
                    name: name,
                    copyAssignees: this.$('.input-copy-assignees').prop('checked'),
                    copyDependencies: this.$('.input-copy-dependencies').prop('checked'),
                    copyComments: this.$('.input-copy-comments').prop('checked'),
                    copyAttachments: this.$('.input-copy-attachments').prop('checked')
                });
                this.model.save(null, {
                    success: _.bind(function () {
                        this.removeModal();
                        PJQ.notifications.notify.successNotify({
                            message: 'Schedule Template Created'
                        });
                    }, this)
                });
            }, this);
        if (existingTemplate != null) {
            new PJQ.views.modals.YesNo({
                header: "Overwrite Template",
                body: "A template already exists with this name.  Would you like to overwrite it?",
                onYes: _.bind(function () {
                    this.model.set('templateId', existingTemplate.id);
                    fnSave();
                }, this)
            });
        } else {
            fnSave();
        }
    }
});

PJQ.views.schedule.UploadTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Upload-Template'),
        maxWidth: 500,
        onImport: null,
        weekendWork: true
    },
    events: {
        'change .cb-weekend-work': 'weekendWorkChanged'
    },
    renderData: function () {
        return {
            weekendWork: this.options.weekendWork
        };
    },
    afterRender: function () {
        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.template-uploader'),
            allowedExtensions: ['mpp', 'mpx', 'mspdi', 'pp'],
            previewImageDimension: 150,
            onDrop: () => {
                this.$('.import-loading').removeClass('hidden');
                this.$('.btn-close').prop('disabled', true);
            },
            onSuccess: (file) => {
                let loader = new PJQ.Loader(this.$('.modal-body'));
                if (_.size(file.folder) > 0) {
                    let req =
                        {
                            weekendWork: this.options.weekendWork,
                            file: {
                                name: file.fileData.fileName,
                                folder: file.folder
                            }
                        };
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: this.options.project.id
                            },
                            {
                                endpoint: 'schedule'
                            },
                            {
                                endpoint: 'processupload'
                            }
                        ]),
                        data: req
                    }).post().done((res) => {
                        if (typeof this.options.onImport === 'function') {
                            this.options.onImport();
                        }
                        this.removeModal();
                    }).fail((xhr, err, result) => {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Encountered an error processing the schedule import.  Please try again or contact customer service.'
                        });
                    });
                }
            },
        });
    },
    makeUploadEndpoint: function () {
        let params = [{
            parameter: 'weekendWork',
            value: this.options.weekendWork
        }];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'upload'
            }
        ], params)
    },
    weekendWorkChanged: function (e) {
        this.options.weekendWork = $(e.currentTarget).prop('checked');
        this.fileUploader.options.endpoint = this.makeUploadEndpoint();
    }
});

PJQ.views.schedule.ImportTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Import-Template'),
        maxWidth: 500,
        onImport: null
    },
    events: {
        'click .btn-import': 'save'
    },
    beforeModalCreated: function () {
        this.options.project.fetchScheduleTemplates(_.bind(function (tmp) {
            this.templates = tmp;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            templates: this.templates
        };
    },
    afterRender: function () {
        if (this.templates != null && this.templates.isFetched) {
            this.templatePicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-template'),
                onChange: _.bind(function (value) {
                    this.selectedTemplate = this.templates.get(value);
                }, this),
                isIntChoices: true,
                noneSelectedText: 'Select Template'
            });

            this.startDate = _.size(this.options.project.get('startDate')) > 0 ? new Date(this.options.project.get('startDate')) : null;
            this.startDatePicker = new PJQ.inputs.Datepicker({
                el: this.$('.input-start-date'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.startDate
                },
                onChange: _.bind(function (value) {
                    this.startDate = value;
                }, this)
            });
        }
    },
    save: function () {
        let isValid = true;
        if (this.selectedTemplate == null) {
            this.templatePicker.showError();
            isValid = false;
        } else {
            this.templatePicker.hideError();
        }

        if (this.startDate == null) {
            this.startDatePicker.showError();
            isValid = false;
        } else {
            this.startDatePicker.hideError();
        }

        if (!isValid) {
            return;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'import',
                    value: this.selectedTemplate.id
                }
            ], [
                {
                    parameter: 'start',
                    value: PJQ.helpers.dateHelpers.getDateString(new Date(this.startDate), 'yyyy-MM-dd')
                },
                {
                    parameter: 'importAssignees',
                    value: this.$('.input-import-assignees').prop('checked')
                },
                {
                    parameter: 'importDependencies',
                    value: this.$('.input-import-dependencies').prop('checked')
                },
                {
                    parameter: 'importComments',
                    value: this.$('.input-import-comments').prop('checked')
                }, {
                    parameter: 'importAttachments',
                    value: this.$('.input-import-attachments').prop('checked')
                }
            ]),
            data: { cloudFlareFix: true }
        }).put().done(_.bind(function (response) {
            if (typeof this.options.onImport === 'function') {
                let result = new PJQ.models.schedule.Schedule(response);
                result.isFetched = true;
                this.options.onImport(result);
            }
            this.removeModal();
            PJQ.notifications.notify.successNotify({
                message: 'Schedule Template Imported'
            });
        }, this));
    }
});